import {
  DashboardOutlined,
  AppstoreOutlined,
  UserOutlined,
  CarryOutOutlined,
  InfoCircleOutlined,
  FileImageOutlined,
  CarOutlined,
  PictureOutlined,
  GroupOutlined,
  HomeOutlined,
  WalletOutlined,
  SettingOutlined,
  DollarCircleOutlined,
  FolderOutlined,
  DatabaseOutlined,
  HeartOutlined,
  CommentOutlined,
  PullRequestOutlined,
  CheckCircleOutlined,
  NotificationOutlined,
  DollarOutlined,
  InboxOutlined,
  CrownOutlined,
  QuestionCircleOutlined,
  ContactsOutlined,
  FileOutlined,
  ApartmentOutlined,
  LayoutOutlined,
  TeamOutlined,
  SafetyOutlined,
} from "@ant-design/icons";
import {
  APP_PREFIX_PATH,
  //  AUTH_PREFIX_PATH
} from "configs/AppConfig";



const dashBoardNavTree = [
  {
    key: "dashboards",
    path: `${APP_PREFIX_PATH}/dashboards`,
    title: "sidenav.dashboard",
    icon: DashboardOutlined,
    breadcrumb: false,
    submenu: [
      // {
      //   key: 'dashboards-user',
      //   path: `${APP_PREFIX_PATH}/dashboards/user`,
      //   title: 'Employee',
      //   icon: UserOutlined,
      //   breadcrumb: false,
      //   submenu: []
      // },
      // {
      //   key: 'dashboards-employee-type',
      //   path: `${APP_PREFIX_PATH}/dashboards/employee-type`,
      //   title: 'Employee Types',
      //   icon: AppstoreOutlined,
      //   breadcrumb: false,
      //   submenu: []
      // },
      // {
      //   title: 'Employee',
      //   icon: UserOutlined,
      //   breadcrumb: false,
      //   submenu: [
      //     {
      //       key: 'dashboards-user',
      //       path: `${APP_PREFIX_PATH}/dashboards/user`,
      //       title: 'Employee',
      //       icon: UserOutlined,
      //       breadcrumb: false,
      //       submenu: []
      //     },
      //   ]
      // },
      {
        key: 'dashboards-business-enquiry',
        path: `${APP_PREFIX_PATH}/dashboards/business-enquiry`,
        title: 'Business Enquiry',
        icon: QuestionCircleOutlined,
        breadcrumb: false,
        submenu: []
      },
      //       key: "dashboards-user",
      //       path: `${APP_PREFIX_PATH}/dashboards/user`,
      //       title: "Employee",
      //       icon: UserOutlined,
      //       breadcrumb: false,
      //       submenu: [],
      //     },
      //   ],
      // },
      // {
      //   key: "dashboards-lead",
      //   path: `${APP_PREFIX_PATH}/dashboards/lead-generation`,
      //   title: "Lead Generation",
      //   icon: CheckCircleOutlined,
      //   breadcrumb: false,
      //   submenu: [],
      // },
      {
        key: "dashboards-category",
        path: `${APP_PREFIX_PATH}/dashboards/category`,
        title: "Category",
        icon: ApartmentOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "dashboards-pages",
        path: `${APP_PREFIX_PATH}/dashboards/pages`,
        title: "Pages",
        icon: FileOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "dashboards-contact-us",
        path: `${APP_PREFIX_PATH}/dashboards/contact-us`,
        title: "Contact-Us",
        icon: ContactsOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "dashboards-brands",
        path: `${APP_PREFIX_PATH}/dashboards/brands`,
        title: "Brands",
        icon: CrownOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "dashboards-banner",
        path: `${APP_PREFIX_PATH}/dashboards/banner`,
        title: "Banner",
        icon: PictureOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "dashboards-widgets",
        path: `${APP_PREFIX_PATH}/dashboards/widgets`,
        title: "Widgets",
        permissionKey: "widgets",
        icon: LayoutOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "dashboards-clients",
        path: `${APP_PREFIX_PATH}/dashboards/clients`,
        title: "Clients",
        icon: TeamOutlined,
        breadcrumb: false,
        submenu: [],
      },
      // {
      //   key: "dashboards-contact-details",
      //   path: `${APP_PREFIX_PATH}/dashboards/contact-details`,
      //   title: "Contact-Details",
      //   icon: ContactsOutlined,
      //   breadcrumb: false,
      //   submenu: [],
      // },
      {
        key: "dashboards-contact-details",
        path: `${APP_PREFIX_PATH}/dashboards/contact-details`,
        title: "Contact Details",
        icon: SettingOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "dashboards-masterclass",
        path: `${APP_PREFIX_PATH}/dashboards/masterclass`,
        title: "Masterclass",
        icon: CarryOutOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "dashboards-masterclass-registrations",
            path: `${APP_PREFIX_PATH}/dashboards/masterclass/registrations`,
            title: "Registrations",
            icon: TeamOutlined,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "dashboards-masterclass-payments",
            path: `${APP_PREFIX_PATH}/dashboards/masterclass/payments`,
            title: "Payments",
            icon: DollarOutlined,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "dashboards-masterclass-settings",
            path: `${APP_PREFIX_PATH}/dashboards/masterclass/settings`,
            title: "Settings",
            icon: SettingOutlined,
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "dashboards-information-policy",
        path: `${APP_PREFIX_PATH}/dashboards/information-policy`,
        title: "Information policy",
        icon: InfoCircleOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "dashboards-seo",
        path: `${APP_PREFIX_PATH}/dashboards/seo`,
        title: "SEO",
        icon: SafetyOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
];


const navigationConfig = [
  ...dashBoardNavTree,
  // ...appsNavTree,
  // ...componentsNavTree,
  //  ...extraNavTree,
  // ...docsNavTree,
];

export default navigationConfig;
